//测试环境
// const admin_api = 'http://xgc.api.xiaocx.my/admin';

//测试地址
// const admin_api = 'http://xgc.xiaocx.cc/admin';

// 正式地址
const admin_api = 'https://api.xyxgc.com.cn/admin';

// 上传地址
const upload_url = admin_api + '/ali_oss/index';
const upload_local_url = admin_api + '/Index/upload_img';


export default {
	upload_url,
	admin_api,
	upload_local_url,
}


// WEBPACK FOOTER //
// ./src/util/common.js